module.exports = __webpack_public_path__ + "static/img/Opportunities_EnjoyingLA_Attractions.72c7c35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Opportunities_EnjoyingLA_Attractions.jpg
// module id = rHc2
// module chunks = 1